import {
  MEMBER_ROLE_LABELS,
  MEMBER_ROLE_OPTIONS,
  formatAmount,
  formatPhoneEmail,
} from '../futures/futuresOrderConstants';
import {
  inputDateTimeToQueryApi,
  toInputDateTime,
} from '../futures/futuresRoundConstants';
import {
  depositStatusClassName,
  formatDepositStatus,
  formatOptionalId,
  validateOnlineDepositTimeRange,
} from './onlineDepositConstants';

/** 線下充值審核狀態（PaymentStatusType 子集） */
export const OFFLINE_DEPOSIT_STATUS_OPTIONS = [
  { value: 'PENDING', label: '待處理' },
  { value: 'PROCESSING', label: '處理中' },
  { value: 'SUCCESS', label: '成功' },
  { value: 'FAIL', label: '失敗' },
];

export {
  MEMBER_ROLE_LABELS,
  MEMBER_ROLE_OPTIONS,
  formatAmount,
  formatPhoneEmail,
  depositStatusClassName,
  formatDepositStatus,
  formatOptionalId,
};

export function defaultOfflineDepositApplyTimeRange() {
  const now = new Date();
  const from = new Date(now);
  from.setHours(0, 0, 0, 0);

  const to = new Date(now);
  to.setDate(to.getDate() + 1);
  to.setHours(0, 0, 0, 0);

  return {
    createTimeFromInput: toInputDateTime(from),
    createTimeToInput: toInputDateTime(to),
  };
}

export function validateOfflineDepositTimeRange(fromInput, toInput, label = '申請時間') {
  return validateOnlineDepositTimeRange(fromInput, toInput, label);
}

const DEPOSIT_TYPE_LABELS = {
  RECHARGE_OFFLINE: '線下充值',
  RECHARGE_ONLINE: '線上儲值',
  RECHARGE_SYSTEM: '系統上分',
};

export function formatDepositType(type) {
  if (!type) {
    return '—';
  }
  const code = typeof type === 'string' ? type : type?.name || String(type);
  return DEPOSIT_TYPE_LABELS[code] || code;
}

export function resolveDepositCurrencyAmount(row) {
  if (!row) {
    return null;
  }
  return row.updateCurrencyAmount ?? row.currencyAmount ?? row.amount ?? null;
}

export function resolveDepositExchangeRate(row) {
  if (!row) {
    return null;
  }
  return row.exchangeRate ?? row.rate ?? null;
}

export function resolveDepositRealAmount(row) {
  const amount = resolveDepositCurrencyAmount(row);
  const rate = resolveDepositExchangeRate(row);
  if (amount == null) {
    return row?.realAmount ?? null;
  }
  if (rate == null) {
    return row?.realAmount ?? amount;
  }
  return Number(rate) * Number(amount);
}

export function canEditOfflineDeposit(row) {
  const code = typeof row?.status === 'string' ? row.status : row?.status?.name;
  return code === 'PENDING' || code === 'PROCESSING';
}

/** 已進入後臺處理或審核完成時顯示審核時間 */
export function shouldShowDepositAuditTime(row) {
  const code = typeof row?.status === 'string' ? row.status : row?.status?.name;
  return code === 'PROCESSING' || code === 'SUCCESS' || code === 'FAIL';
}

export function buildOfflineDepositPageParams(pageNo, filters) {
  const params = {
    pageNo,
    pageSize: 15,
  };

  if (filters.id?.trim()) {
    params.id = Number(filters.id);
  }
  if (filters.status) {
    params.status = filters.status;
  }
  if (filters.roleId) {
    params.roleId = Number(filters.roleId);
  }
  if (filters.topInviterId?.trim()) {
    params.topInviterId = Number(filters.topInviterId);
  }
  if (filters.inviterId?.trim()) {
    params.inviterId = Number(filters.inviterId);
  }
  if (filters.memberId?.trim()) {
    params.memberId = Number(filters.memberId);
  }
  if (filters.phoneEmail?.trim()) {
    params.phoneEmail = filters.phoneEmail.trim();
  }
  if (filters.currencyName?.trim()) {
    params.currencyName = filters.currencyName.trim();
  }
  if (filters.address?.trim()) {
    params.address = filters.address.trim();
  }
  if (filters.createTimeFromInput) {
    params.createTimeBegin = inputDateTimeToQueryApi(filters.createTimeFromInput);
  }
  if (filters.createTimeToInput) {
    params.createTimeEnd = inputDateTimeToQueryApi(filters.createTimeToInput);
  }
  if (filters.updateTimeFromInput) {
    params.updateTimeBegin = inputDateTimeToQueryApi(filters.updateTimeFromInput);
  }
  if (filters.updateTimeToInput) {
    params.updateTimeEnd = inputDateTimeToQueryApi(filters.updateTimeToInput);
  }

  return params;
}
